import { render, staticRenderFns } from "./TermsPoint.vue?vue&type=template&id=1e666574&"
import script from "./TermsPoint.vue?vue&type=script&lang=ts&"
export * from "./TermsPoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports